import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { BackgroundColorContainer, Heading, Paragraph } from '../../atoms';
import { ResponsiveImage } from '../ResponsiveImage';
import {
  ContentContainer,
  ContactInfo,
  ContactMethod,
  IconContainer,
  Heading1,
  PageHeadings,
  StyledGladly,
  ContactsContainer,
  Bubble,
  ContactInfoText,
  ContactInfoTitle,
  HeadingContainer,
  ContactInfoTextContainer,
} from './styles.js';
import { GLADLY_CONFIG, GLADLY_INIT_SCRIPT_ID, loadGladly } from './config';

export const Gladly = ({
  contactHeading,
  contactMethods,
  heading1,
  heading2,
}) => {
  const [loaded, setLoaded] = useState(false);
  const onChatButtonHandler = () => {
    const { Gladly } = window;
    if (Gladly.show) Gladly.show();
  };

  useEffect(() => {
    if (typeof window !== 'undefined' && !loaded) {
      window.gladlyHCConfig = GLADLY_CONFIG;
      loadGladly(() => {
        setLoaded(true);
      });

      return function cleanup() {
        // Gladly loads when one of these injected scripts invokes.
        // Remove scripts to allow successful page load if user leaves and comes back.
        document.getElementById(GLADLY_INIT_SCRIPT_ID).remove();
        Array.from(document.getElementsByTagName('script'))
          .filter(scriptTag => scriptTag.src.match(/cdn\.gladly\.com/))
          .forEach(element => element.remove());
        window.gladlyHCLoaded = false;
      };
    }
  }, [loaded]);

  return (
    <BackgroundColorContainer bgColor="background.base">
      <ContentContainer>
        <PageHeadings>
          <Heading1>{heading1}</Heading1>
          <Heading
            headingText={heading2}
            headingLevel="h2"
            typography="heading1"
          />
        </PageHeadings>
        <StyledGladly id="gladly-help-center" />
        <ContactInfo>
          <HeadingContainer>
            <Heading
              headingText={contactHeading}
              headingLevel="h3"
              typography="heading2"
              position="center"
            />
          </HeadingContainer>
          <ContactsContainer>
            {contactMethods.map((contact, i) => {
              const [width, height] = [29, 29];
              return (
                <ContactMethod key={i}>
                  <Bubble
                    href={contact.path}
                    onClick={
                      contact.title === 'Live chat with'
                        ? onChatButtonHandler
                        : null
                    }
                  >
                    <IconContainer>
                      <ResponsiveImage
                        src={contact.icon.src}
                        alt={contact.icon.alt}
                        id={`contact_${i}`}
                        width={width}
                        height={height}
                      />
                    </IconContainer>
                  </Bubble>
                  <ContactInfoTitle>{contact.title}</ContactInfoTitle>
                  <ContactInfoTextContainer
                    onClick={
                      contact.title === 'Live chat with'
                        ? onChatButtonHandler
                        : null
                    }
                  >
                    <ContactInfoText href={contact.path}>
                      {contact.text}{' '}
                    </ContactInfoText>
                    {contact.title === 'Text us' && (
                      <Paragraph>Message & Data rates may apply.</Paragraph>
                    )}
                  </ContactInfoTextContainer>
                </ContactMethod>
              );
            })}
          </ContactsContainer>
        </ContactInfo>
      </ContentContainer>
    </BackgroundColorContainer>
  );
};

Gladly.displayName = 'Gladly';
Gladly.propTypes = {
  heading1: PropTypes.string.isRequired,
  heading2: PropTypes.string.isRequired,
  contactHeading: PropTypes.string.isRequired,
  contactMethods: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      icon: PropTypes.shape({
        alt: PropTypes.string.isRequired,
        src: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
          .isRequired,
      }).isRequired,
    }).isRequired,
  ),
};
